export const tripMode = {
  TRIP_BETWEEN_ENTITIES: 'TRIP_BETWEEN_ENTITIES',
  TRIP_TO_CUSTOMER: 'TRIP_TO_CUSTOMER'
}

export const reportField = {
  NUMBER_DISPATCH: 'N° de despacho',
  TEXT_FOR_TRIP: 'Por Viajes',
  IMPORT_EXCEL_BY_DISPATCHES: 'importExcelByDispatches',
  DISPATCHES_TO_LOAD_TRIP: 'dispatchesToLoadTrip',
  TRIP_CREATED: 'TRIP_CREATED',
  DISPATCH_MODULE: 'DISPATCH_MODULE',
  REGULAR: 'REGULAR',
  COURRIER: 'COURRIER',
  TRIP_TO_CUSTOMER: 'TRIP_TO_CUSTOMER',
  DAD: 'DAD'
}
